import { Column } from "react-table"

export default [
    {
        Header: 'Name',
        accessor: 'name',
        width: "100%"
    },
    {
        Header: 'Email',
        accessor: 'email',
        width: 300
    },
    {
        Header: 'Country',
        accessor: 'country'
    },
    {
        Header: 'Sections',
        accessor: ({ sections }) => sections.length
    }
] as Column<Admin.Resources.Jury>[]